import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/GlassBrickCalculator/glassBrickCalculator.container"
    ).then((module) => ({
        default: module.GlassBrickCalculator
    }))
);
